import { NCCluster } from '../../../../src/commonTypes';
import { NCNode, NCLink } from '../../../../src/commonTypes';
import { getDistanceBetweenPoints } from './geometryUtils';
import { getLinksInvolvingNode } from './linkUtils';

export const isSameCluster = (cluster1: NCCluster, cluster2: NCCluster): boolean => {
	return cluster1.group === cluster2.group && cluster1.values.length === cluster2.values.length;
};
